import React from 'react';

const FormGeneratorPublicConfig = {
  settings: {
    layout: {
      config: {
        navbar: { display: false },
        toolbar: { display: false },
        footer: { display: false }
      }
    }
  },
  auth: null,
  routes: [
    {
      path: '/:slug',
      exact: true,
      component: React.lazy(() => import('./FormGeneratorPublicPage'))
    }
  ]
};

export default FormGeneratorPublicConfig;
